import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'None', value: '' },
  { label: 'qcow2', value: 'qcow2' },
  { label: 'raw', value: 'raw' },
  { label: 'iso', value: 'iso' },
  { label: 'vmdk', value: 'vmdk' },
]

interface Props {}

export default function DiskFormatPicklist({
  name = 'diskFormat',
  label = 'Disk Format',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
